import './index.scss';

import { Component } from 'react';
import { BraxModal } from 'design-system';

import t from '../../utils/i18n';

export type PaymentConfirmationProps = {
    open?: boolean,
    confirmed: boolean,
    message: string,
    onClose?: () => void
};

export default class PaymentConfirmation extends Component<PaymentConfirmationProps> {

    render() {
        return (
            <BraxModal open={this.props.open} size="md" className="payment-confirmation" onClose={this.props.onClose}>
                <h2>{ t(this.props.confirmed ? 'Pagamento confirmado!' : 'Pagamento não confirmado!') }</h2>

                <p>{ this.props.message }</p>
            </BraxModal>
        );
    }

}
